import React from 'react';

const DailyLawyerDashboardSection = ({
  appliedRange,
  buildRangeLabel,
  error,
  form,
  formatCount,
  loading,
  onShow,
  rows,
  setForm,
  today,
  topOptions,
  total,
}) => (
  <div className="perf-section">
    <div className="perf-section-head">
      <h4>Daily Lawyer Dashboard</h4>
      <div className="perf-mini-filters">
        <label>
          <span>Date From</span>
          <input
            type="date"
            value={form.dateFrom}
            max={today}
            onChange={(e) => setForm((prev) => ({ ...prev, dateFrom: e.target.value }))}
          />
        </label>
        <label>
          <span>Date To</span>
          <input
            type="date"
            value={form.dateTo}
            max={today}
            onChange={(e) => setForm((prev) => ({ ...prev, dateTo: e.target.value }))}
          />
        </label>
        <label>
          <span>Top Count</span>
          <select
            value={form.topN}
            onChange={(e) => setForm((prev) => ({ ...prev, topN: e.target.value }))}
          >
            {topOptions.map((count) => (
              <option key={count} value={count}>{`Top ${count}`}</option>
            ))}
          </select>
        </label>
        <button
          className="btn btn-soft"
          type="button"
          onClick={() => setForm((prev) => ({ ...prev, dateFrom: today, dateTo: today }))}
        >
          Today
        </button>
        <button className="btn btn-primary" type="button" onClick={onShow} disabled={loading}>
          {loading ? 'Loading...' : 'Show'}
        </button>
      </div>
    </div>

    {error ? <div className="perf-empty">{error}</div> : null}

    {!error && !rows.length && !loading ? (
      <div className="perf-empty">No advocate performance data found.</div>
    ) : null}

    {!error && !!rows.length ? (
      <div className="perf-lawyer-grid">
        {rows.map((row) => (
          <article className="perf-lawyer-card" key={row.id}>
            <span>{row.name}</span>
            <strong>{formatCount(row.total, true)}</strong>
            <em>{buildRangeLabel(appliedRange.from, appliedRange.to)}</em>
          </article>
        ))}
        <article className="perf-lawyer-card highlight">
          <span>{appliedRange.from === today && appliedRange.to === today ? "Today's Registered Queries" : 'Registered Queries'}</span>
          <strong>{formatCount(total, true)}</strong>
          <em>{`Top ${appliedRange.topN}`}</em>
        </article>
      </div>
    ) : null}
  </div>
);

export default DailyLawyerDashboardSection;
